import { useQuery } from '@tanstack/react-query';
import { fetchPendingReceipts, type ListPendingParams } from '../api/receipts';
import type { Receipt } from '@deposits/shared';

export function useReceiptsPending(params: ListPendingParams | null) {
  return useQuery<Receipt[]>({
    queryKey: ['receipts-pending', params],
    queryFn: () => fetchPendingReceipts(params!),
    enabled: params != null,
    staleTime: 30_000,
  });
}
